import { fetchUtils } from 'react-admin';

export const apiUrl = process.env.REACT_APP_API_HOST_ADMIN ?? '';

const buildRequestOptions = options => {
  const token = localStorage.getItem('token');
  const customHeaders = options.headers ? options.headers : {},
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    optionsHeaders = { ...headers, ...customHeaders };

  options.headers = optionsHeaders;
  options.mode = 'cors';

  return options;
};

export const httpClient = (url, options = {}) => {
  options = buildRequestOptions(options);
  options.headers = new Headers(options.headers);
  return fetchUtils.fetchJson(url, options).catch(error => {
    if (error && error.status && error.status === 401) {
      localStorage.clear();
      window.location.href = '/#/login';
      return Promise.reject(error);
    }
    return error;
  });
};

export const httpSimple = (url, options = {}) => {
  options = {
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  };
  options.mode = 'cors';
  options.headers = new Headers(options.headers);
  return fetchUtils.fetchJson(url, options);
};

export const sendAsFormData = (method, resource, params) => {
  const formData = new FormData();
  for (const name in params.data) {
    const value = params.data[name];
    if (Array.isArray(value)) {
      // Send array elements as separate form fields with [] suffix
      value.forEach(item => {
        formData.append(`${name}[]`, item);
      });
    } else {
      formData.append(name, value || '');
    }
  }

  if (resource === 'media') {
    if (params.data.media_type === 'image') {
      params.data.picture?.forEach(file => {
        formData.append('images[]', file.rawFile);
      });
    }
    if (params.data.media_type === 'file') {
      formData.set('file', params.data.file.rawFile);
    }
  }

  if (resource === 'members' && params.data.avatar_file) {
    formData.set('avatar_file', params.data.avatar_file.rawFile);
  }

  if (method === 'PUT') {
    formData.append('_method', 'PUT');
    resource = `${resource}/${params.id}`;
    method = 'POST';
  }

  const options = buildRequestOptions({
    ...params,
    method: method,
    body: formData,
  });
  delete options['data'];
  delete options.headers['Content-Type'];

  return fetch(`${apiUrl}/${resource}`, options)
    .then(async res => {
      if (res.status >= 200 && res.status < 300) {
        return res.json();
      }
      throw await res.json();
    })
    .then(json => {
      return {
        data: { ...params.data, id: json.id, response: json },
      };
    })
    .catch(error => {
      let message = '';
      if (error.error && typeof error.error === 'object') {
        // eslint-disable-next-line no-unused-vars
        for (const [_key, value] of Object.values(error.error)) {
          message += ` ${value}`;
        }
      }
      throw new Error(message ? `Error: ${message}` : 'ra.message.error');
    });
};

// API functions for quality notes
export const notesApi = {
  getRealTimeNotes: async (params = {}) => {
    const {
      page = 1,
      per_page = 10,
      seccion,
      search,
      order_by,
      order_direction,
    } = params;
    const searchParams = new URLSearchParams();

    searchParams.append('page', page);
    searchParams.append('per_page', per_page);

    if (seccion) searchParams.append('seccion', seccion);
    if (search) searchParams.append('search', search);
    if (order_by) searchParams.append('order_by', order_by);
    if (order_direction)
      searchParams.append('order_direction', order_direction);

    const url = `${apiUrl}/quality/realtime?${searchParams.toString()}`;
    const response = await httpClient(url, { method: 'GET' });
    return response.json;
  },

  getHistoricalNotes: async (params = {}) => {
    const {
      page = 1,
      per_page = 10,
      date_range,
      seccion,
      search,
      start_date,
      end_date,
      order_by,
      order_direction,
    } = params;
    const searchParams = new URLSearchParams();

    searchParams.append('page', page);
    searchParams.append('per_page', per_page);

    if (date_range) searchParams.append('date_range', date_range);
    if (seccion) searchParams.append('seccion', seccion);
    if (search) searchParams.append('search', search);
    if (start_date) searchParams.append('start_date', params.start_date);
    if (end_date) searchParams.append('end_date', params.end_date);
    if (order_by) searchParams.append('order_by', order_by);
    if (order_direction)
      searchParams.append('order_direction', order_direction);

    const url = `${apiUrl}/quality/historic?${searchParams.toString()}`;
    const response = await httpClient(url, { method: 'GET' });
    return response.json;
  },

  getSections: async () => {
    const url = `${apiUrl}/sections`;
    const response = await httpClient(url, { method: 'GET' });
    const json = response.json;
    if (Array.isArray(json?.data)) {
      return json.data?.map(section => ({
        ...section,
        value: section.seccion,
      }));
    }
    return [];
  },
};
